import { useMemo } from 'react'

import { useAdminDashboardStats } from './useAdminDashboardStats'
import { useAdminMetrics } from './useAdminMetrics'
import { useAllVms } from './useAllVms'
import { useResourceStats } from './useResourceStats'
import { useVmReadiness } from './useVmReadiness'
import { buildVmActivity, countLaunchedVms } from './vmActivity'

export function useDashboardQueries() {
  const resources = useResourceStats()
  const vmsQuery = useAllVms()
  const vmReadinessQuery = useVmReadiness()
  const statsQuery = useAdminDashboardStats()
  const metricsQuery = useAdminMetrics()

  const queries = [
    ...resources.queries,
    vmsQuery,
    vmReadinessQuery,
    statsQuery,
    metricsQuery,
  ]

  const stats = statsQuery.data
  const newVms = metricsQuery.data?.newVms
  const vms = vmsQuery.data
  // Created comes from the server; a failed VM list only drops Terminated.
  const vmsSettled = vmsQuery.isSuccess || vmsQuery.isError
  const vmActivity = useMemo(
    () => (newVms && vmsSettled ? buildVmActivity(newVms, vms) : undefined),
    [newVms, vms, vmsSettled],
  )

  return {
    stats,
    statsLoading: statsQuery.isLoading,
    statsError: statsQuery.isError,
    activeVms: stats ? countLaunchedVms(stats.vmsByStatus) : undefined,
    storage: resources.storage,
    ips: resources.ips,
    metrics: metricsQuery.data,
    metricsLoading: metricsQuery.isLoading,
    metricsError: metricsQuery.isError,
    vmActivity,
    vmActivityLoading: vmsQuery.isLoading || metricsQuery.isLoading,
    vmReadiness: vmReadinessQuery.data,
    vmReadinessLoading: vmReadinessQuery.isLoading,
    queries,
  }
}
